import { render } from "./CampaignDashboard.vue?vue&type=template&id=3821796d&scoped=true"
import script from "./CampaignDashboard.vue?vue&type=script&lang=js"
export * from "./CampaignDashboard.vue?vue&type=script&lang=js"

import "./CampaignDashboard.vue?vue&type=style&index=0&id=3821796d&scoped=true&lang=css"

import exportComponent from "/Users/bytedance/New/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3821796d"]])

export default __exports__